import ymt from '../modules/ymt.js'
export default [
	//工作台
	{path: '/ymt/index.htm',name:'indexY', component:ymt.index},
	// 登录页
	{path: '/ymt/login.htm',name:'loginY', component:ymt.login},
	// 各机构报价详情
	{path: '/ymt/quoteDetail.htm',name:'quoteDetailY', component:ymt.quoteDetail},
	// 询价详情
	{path: '/ymt/xjDetail.htm',name:'xjDetailY', component:ymt.xjDetail},
	// 个人中心
	{path: '/ymt/personalCenter.htm',name:'personalCenterY', component:ymt.personalCenter},
	// 富民下载
	{path: '/ymt/downLoad.htm',name:'downLoadY', component:ymt.downLoad},
	//机构推荐人介绍
	{path: '/ymt/referrerInfo.htm',name:'referrerInfoY', component:ymt.referrerInfo},
] 